
// import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// const COURSE_URL = "https://fetc.in/api/v1/courses";

// export const courseApi = createApi({
// reducerPath: "coursesApi",
// tagTypes: ["Courses", "Progress"],

// baseQuery: fetchBaseQuery({
// baseUrl: COURSE_URL,
// credentials: "include", // send cookies/JWT
// }),

// endpoints: (builder) => ({


// /* -----------------------------------------
//    CREATE COURSE (FormData)
// ----------------------------------------- */
// createCourse: builder.mutation({
//   query: (formData) => ({
//     url: "/create",
//     method: "POST",
//     body: formData,
//   }),
//   invalidatesTags: ["Courses"],
// }),

// /* -----------------------------------------
//    GET COURSES
// ----------------------------------------- */
// getCourses: builder.query({
//   query: () => "/list",
//   providesTags: ["Courses"],
// }),

// getPublishedCourses: builder.query({
//   query: () => "/published",
//   providesTags: ["Courses"],
// }),

// getCreatorCourses: builder.query({
//   query: () => "/user",
//   providesTags: ["Courses"],
// }),

// /* -----------------------------------------
//    GET COURSE BY SLUG
// ----------------------------------------- */
// getCourseBySlug: builder.query({
//   query: (slug) => `/${slug}`,
//   providesTags: (result, error, slug) => [
//     { type: "Courses", id: slug }
//   ],
//   keepUnusedDataFor: 0,
// }),



// /* -----------------------------------------
//    PROGRESS DATA
// --------------------------
// --------------- */
// getCourseProgress: builder.query({
//   query: (courseId) => `/${courseId}/progress`,
//   providesTags: (r, e, courseId) => [
//     { type: "Progress", id: courseId }
//   ],
//   transformResponse: (response) => ({
//   lessonsProgress: Array.isArray(response.lessonsProgress)
//     ? response.lessonsProgress
//     : [],
//   percentage: Number(response.percentage) || 0,
//   score: Number(response.score) || 0,
//   isCompleted: !!response.isCompleted,
// }),

// }),

// /* -----------------------------------------
//    COURSE RESULT
// ----------------------------------------- */
// getCourseResult: builder.query({
//   query: (courseId) => `/${courseId}/result`,
// }),

// saveCourseResult: builder.mutation({
//   query: ({ courseId, result }) => ({
//     url: `/${courseId}/result`,
//     method: "POST",
//     body: result,
//   }),
//   invalidatesTags: (r, e, { courseId }) => [
//     { type: "Progress", id: courseId },
//   ],
// }),

// /* -----------------------------------------
//    EDIT COURSE
// ----------------------------------------- */
// editCourse: builder.mutation({
//   query: ({ slug, data }) => ({
//     url: `/${slug}`,
//     method: "PUT",
//     body: data,
//   }),
//   invalidatesTags: (r, e, { slug }) => [
//     { type: "Courses", id: slug },
//     "Courses",
//   ],
// }),

// /* -----------------------------------------
//    DELETE COURSE
// ----------------------------------------- */
// deleteCourse: builder.mutation({
//   query: (slug) => ({
//     url: `/${slug}`,
//     method: "DELETE",
//   }),
//   invalidatesTags: ["Courses"],
// }),

// /* -----------------------------------------
//    FILE UPLOAD HELPERS
// ----------------------------------------- */
// uploadCourseFile: builder.mutation({
//   query: (formData) => ({
//     url: "/upload/file",
//     method: "POST",
//     body: formData,
//   }),
// }),

// uploadCourseAudio: builder.mutation({
//   query: (formData) => ({
//     url: "/upload/audio",
//     method: "POST",
//     body: formData,
//   }),
// }),


// uploadCourseImage: builder.mutation({
//   query: (formData) => ({
//     url: "/upload/image",
//     method: "POST",
//     body: formData,
//   }),
// }),

// uploadCourseVideo: builder.mutation({
//   query: (formData) => ({
//     url: "/upload/video",
//     method: "POST",
//     body: formData,
//   }),
// }),

// /* -----------------------------------------
//    ADD LESSON
// ----------------------------------------- */
// addLesson: builder.mutation({
//   query: ({ courseSlug, lessonData }) => ({
//     url: `/${courseSlug}/lessons`,
//     method: "POST",
//     body: lessonData, // can be JSON or FormData
//   }),
//   invalidatesTags: (r, e, { courseSlug }) => [
//     { type: "Courses", id: courseSlug },
//   ],
// }),



// /* -----------------------------------------
//    EDIT LESSON
// ----------------------------------------- */
// editLesson: builder.mutation({
//   query: ({ courseSlug, lessonId, lessonData }) => ({
//     url: `/${courseSlug}/lessons/${lessonId}`,
//     method: "PUT",
//     body: lessonData,  // can be JSON or FormData
//   }),
//   invalidatesTags: (r, e, { courseSlug }) => [
//     { type: "Courses", id: courseSlug },
//   ],
// }),


// deleteLesson: builder.mutation({
//   query: ({ courseSlug, lessonId }) => ({
//     url: `/${courseSlug}/lessons/${lessonId}`,
//     method: "DELETE",
//   }),
//   invalidatesTags: (r, e, { courseSlug }) => [
//     { type: "Courses", id: courseSlug },
//   ],
// }),

// /* -----------------------------------------
//    UPDATE LESSON COMPLETION
// ----------------------------------------- */
// updateLessonCompletion: builder.mutation({
//   query: ({ courseId, lessonId, completed, score }) => ({
//     url: `/${courseId}/lessons/${lessonId}/completion`,
//     method: "PUT",
//     body: { completed, score },
//   }),
//   invalidatesTags: (r, e, { courseId }) => [
//     { type: "Progress", id: courseId },
//   ],
// }),

// startLessonExercise: builder.mutation({
//   query: ({ courseId, lessonId }) => ({
//     url: `/student/lessons/${lessonId}/start`,
//     method: "POST",
//   }),
// }),

// // Submit attempt
// submitLessonExercise: builder.mutation({
//   query: ({ attemptId, answers }) => ({
//     url: `/student/attempts/${attemptId}/submit`,
//     method: "POST",
//     body: { answers },
//   }),
// }),

// // Get result
// getLessonResult: builder.query({
//   query: (attemptId) => `/student/attempts/${attemptId}/result`,
// }),

// }),
// });

// /* -----------------------------------------
// EXPORTED HOOKS
// ----------------------------------------- */
// export const {
// useCreateCourseMutation,
// useGetCoursesQuery,
// useGetPublishedCoursesQuery,
// useGetCreatorCoursesQuery,
// useGetCourseBySlugQuery,
// useGetCourseProgressQuery,
// useEditCourseMutation,
// useDeleteCourseMutation,
// useAddLessonMutation,
// useEditLessonMutation,
// useGetCourseResultQuery,
// useUpdateLessonCompletionMutation,
// useSaveCourseResultMutation,
// useUploadCourseFileMutation,
// useUploadCourseImageMutation,
// useUploadCourseVideoMutation,
// useUploadCourseAudioMutation,
// useDeleteLessonMutation,
// } = courseApi;

// import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// const COURSE_URL = "https://fetc.in/api/v1/courses";

// /* =========================================
//    BASE QUERY
// ========================================= */
// const baseQuery = fetchBaseQuery({
//   baseUrl: COURSE_URL,
//   credentials: "include",

//   prepareHeaders: (headers, { getState }) => {
//     const token = getState()?.auth?.token;

//     if (token) {
//       headers.set("authorization", `Bearer ${token}`);
//     }

//     headers.set("Accept", "application/json");

//     return headers;
//   },
// });

// /* =========================================
//    API
// ========================================= */
// export const courseApi = createApi({
//   reducerPath: "coursesApi",
//   baseQuery,
//   tagTypes: ["Courses", "Progress", "Attempts", "Results"],

//   endpoints: (builder) => ({

//     /* =========================================
//        COURSES
//     ========================================= */

//     getCourses: builder.query({
//       query: () => "/list",
//       providesTags: ["Courses"],
//     }),

//     getPublishedCourses: builder.query({
//       query: () => "/published",
//       providesTags: ["Courses"],
//     }),

//     getCreatorCourses: builder.query({
//       query: () => "/creator",
//       providesTags: ["Courses"],
//     }),

//     getCourseBySlug: builder.query({
//       query: (slug) => `/${slug}`,
//       providesTags: (r, e, slug) => [{ type: "Courses", id: slug }],
//       keepUnusedDataFor: 0,
//     }),

//     getCourseById: builder.query({
//       query: (id) => `/id/${id}`,
//     }),

//     /* =========================================
//        CREATE / UPDATE / DELETE
//     ========================================= */

//     createCourse: builder.mutation({
//       query: (formData) => ({
//         url: "/create",
//         method: "POST",
//         body: formData,
//       }),
//       invalidatesTags: ["Courses"],
//     }),

//     editCourse: builder.mutation({
//       query: ({ slug, data }) => ({
//         url: `/${slug}`,
//         method: "PUT",
//         body: data,
//       }),
//       invalidatesTags: (r, e, { slug }) => [
//         { type: "Courses", id: slug },
//         "Courses",
//       ],
//     }),

//     deleteCourse: builder.mutation({
//       query: (slug) => ({
//         url: `/${slug}`,
//         method: "DELETE",
//       }),
//       invalidatesTags: ["Courses"],
//     }),

//     /* =========================================
//        PROGRESS
//     ========================================= */

//     getCourseProgress: builder.query({
//       query: (courseId) => `/${courseId}/progress`,
//       providesTags: (r, e, courseId) => [
//         { type: "Progress", id: courseId },
//       ],
//       transformResponse: (res) => ({
//         lessonsProgress: Array.isArray(res?.lessonsProgress)
//           ? res.lessonsProgress
//           : [],
//         percentage: Number(res?.percentage) || 0,
//         score: Number(res?.score) || 0,
//         isCompleted: Boolean(res?.isCompleted),
//       }),
//     }),

//     /* =========================================
//    RESULTS
// ========================================= */

// // 👨‍🎓 STUDENT (own result)
// getCourseResult: builder.query({
//   query: (courseId) => `/${courseId}/result`,
//   providesTags: (r, e, courseId) => [
//     { type: "Results", id: courseId },
//   ],
// }),

// // 👨‍💼 ADMIN (check specific student)
// getStudentCourseResult: builder.query({
//   query: ({ courseId, studentId }) =>
//     `/${courseId}/result/${studentId}`,
// }),



//     saveCourseResult: builder.mutation({
//       query: ({ courseId, lessonId, score }) => ({
//         url: `/${courseId}/result`,
//         method: "POST",
//         body: { lessonId, score },
//       }),
//       invalidatesTags: (r, e, { courseId }) => [
//         { type: "Results", id: courseId },
//         { type: "Progress", id: courseId },
//       ],
//     }),

//     /* =========================================
//        LESSONS
//     ========================================= */

//     addLesson: builder.mutation({
//       query: ({ courseSlug, lessonData }) => ({
//         url: `/${courseSlug}/lessons`,
//         method: "POST",
//         body: lessonData,
//       }),
//       invalidatesTags: (r, e, { courseSlug }) => [
//         { type: "Courses", id: courseSlug },
//       ],
//     }),

//     editLesson: builder.mutation({
//       query: ({ courseSlug, lessonId, lessonData }) => ({
//         url: `/${courseSlug}/lessons/${lessonId}`,
//         method: "PUT",
//         body: lessonData,
//       }),
//       invalidatesTags: (r, e, { courseSlug }) => [
//         { type: "Courses", id: courseSlug },
//       ],
//     }),

//     deleteLesson: builder.mutation({
//       query: ({ courseSlug, lessonId }) => ({
//         url: `/${courseSlug}/lessons/${lessonId}`,
//         method: "DELETE",
//       }),
//       invalidatesTags: (r, e, { courseSlug }) => [
//         { type: "Courses", id: courseSlug },
//       ],
//     }),

//     /* =========================================
//        LESSON COMPLETION
//     ========================================= */

//     updateLessonCompletion: builder.mutation({
//       query: ({ courseId, lessonId, completed, score }) => ({
//         url: `/${courseId}/lessons/${lessonId}/completion`,
//         method: "PUT",
//         body: { completed, score },
//       }),
//       invalidatesTags: (r, e, { courseId }) => [
//         { type: "Progress", id: courseId },
//       ],
//     }),

//     /* =========================================
//        ATTEMPT SYSTEM
//     ========================================= */

//     startLessonExercise: builder.mutation({
//       query: ({ lessonId }) => ({
//         url: `/student/lessons/${lessonId}/start`,
//         method: "POST",
//       }),
//       invalidatesTags: ["Attempts"],
//     }),

//     saveExerciseAnswer: builder.mutation({
//       query: ({ attemptId, exerciseId, answer, correct }) => ({
//         url: `/student/attempts/${attemptId}/answer`,
//         method: "POST",
//         body: { exerciseId, answer, correct },
//       }),
//       invalidatesTags: (r, e, { attemptId }) => [
//         { type: "Attempts", id: attemptId },
//       ],
//     }),

//     submitLessonExercise: builder.mutation({
//   query: ({ attemptId, answers, timeSpent }) => ({
//     url: `/student/attempts/${attemptId}/submit`,
//     method: "POST",
//     body: { answers, timeSpent },
//   }),
//       invalidatesTags: ["Results", "Progress"],
//     }),

//     getLessonResult: builder.query({
//       query: (attemptId) =>
//         `/student/attempts/${attemptId}/result`,
//       providesTags: (r, e, attemptId) => [
//         { type: "Results", id: attemptId },
//       ],
//       keepUnusedDataFor: 0,
//     }),

//     /* =========================================
//        FILE UPLOADS
//     ========================================= */

//     uploadCourseFile: builder.mutation({
//       query: (formData) => ({
//         url: "/upload/file",
//         method: "POST",
//         body: formData,
//       }),
//     }),

//     uploadCourseAudio: builder.mutation({
//       query: (formData) => ({
//         url: "/upload/audio",
//         method: "POST",
//         body: formData,
//       }),
//     }),

//     uploadCourseImage: builder.mutation({
//       query: (formData) => ({
//         url: "/upload/image",
//         method: "POST",
//         body: formData,
//       }),
//     }),

//     getAttemptById: builder.query({
//   query: (attemptId) => `/student/attempts/${attemptId}`,
// }),


//     uploadCourseVideo: builder.mutation({
//       query: (formData) => ({
//         url: "/upload/video",
//         method: "POST",
//         body: formData,
//       }),
//     }),

//   }),
// });

// /* =========================================
//    EXPORT HOOKS
// ========================================= */

// export const {
//   useCreateCourseMutation,
//   useEditCourseMutation,
//   useDeleteCourseMutation,
//   useGetAttemptByIdQuery,

//   useGetCoursesQuery,
//   useGetPublishedCoursesQuery,
//   useGetCreatorCoursesQuery,

//   useGetCourseBySlugQuery,
//   useGetCourseByIdQuery,
//   useGetCourseProgressQuery,

//   useAddLessonMutation,
//   useEditLessonMutation,
//   useDeleteLessonMutation,

//   useUpdateLessonCompletionMutation,

//   useGetCourseResultQuery,
//   useGetStudentCourseResultQuery,
//   useSaveCourseResultMutation,

//   useStartLessonExerciseMutation,
//   useSaveExerciseAnswerMutation,
//   useSubmitLessonExerciseMutation,
//   useLazyGetLessonResultQuery,

//   useUploadCourseFileMutation,
//   useUploadCourseImageMutation,
//   useUploadCourseVideoMutation,
//   useUploadCourseAudioMutation,
// } = courseApi;






import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const COURSE_URL = "https://fetc.in/api/v1/courses";

/* =========================================
   BASE QUERY
========================================= */
const baseQuery = fetchBaseQuery({
  baseUrl: COURSE_URL,
  credentials: "include",
  prepareHeaders: (headers, { getState }) => {
    const token = getState()?.auth?.token;
    if (token) {
      headers.set("authorization", `Bearer ${token}`);
    }
    headers.set("Accept", "application/json");
    return headers;
  },
});

/* =========================================
   API
========================================= */
export const courseApi = createApi({
  reducerPath: "coursesApi",
  baseQuery,
  tagTypes: ["Courses", "Progress", "Attempts", "Results"],
  endpoints: (builder) => ({
    /* ================= COURSES ================= */
    getCourses: builder.query({
      query: () => "/list",
      providesTags: ["Courses"],
    }),

    getPublishedCourses: builder.query({
      query: () => "/published",
      providesTags: ["Courses"],
    }),

    getCreatorCourses: builder.query({
      query: () => "/creator",
      providesTags: ["Courses"],
    }),

    getCourseBySlug: builder.query({
      query: (slug) => `/${slug}`,
      providesTags: (result, error, slug) => [{ type: "Courses", id: slug }],
      keepUnusedDataFor: 300, // 5 minutes
    }),

    getCourseById: builder.query({
      query: (id) => `/id/${id}`,
    }),

    /* ================= COURSE CRUD ================= */
    createCourse: builder.mutation({
      query: (formData) => ({
        url: "/create",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["Courses"],
    }),

    editCourse: builder.mutation({
      query: ({ slug, data }) => ({
        url: `/${slug}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (result, error, { slug }) => [
        { type: "Courses", id: slug },
        "Courses",
      ],
    }),

    deleteCourse: builder.mutation({
      query: (slug) => ({
        url: `/${slug}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Courses"],
    }),

    /* ================= PROGRESS ================= */
    getCourseProgress: builder.query({
      query: (courseId) => `/${courseId}/progress`,
      providesTags: (result, error, courseId) => [
        { type: "Progress", id: courseId },
      ],
    }),

    /* ================= RESULTS ================= */
    getCourseResult: builder.query({
      query: (courseId) => `/${courseId}/result`,
      providesTags: (result, error, courseId) => [
        { type: "Results", id: courseId },
      ],
    }),

    getStudentCourseResult: builder.query({
      query: ({ courseId, studentId }) => `/${courseId}/result/${studentId}`,
    }),

    /* ================= LESSONS ================= */
    addLesson: builder.mutation({
      query: ({ courseSlug, lessonData }) => ({
        url: `/${courseSlug}/lessons`,
        method: "POST",
        body: lessonData,
      }),
      invalidatesTags: (result, error, { courseSlug }) => [
        { type: "Courses", id: courseSlug },
      ],
    }),

    editLesson: builder.mutation({
      query: ({ courseSlug, lessonId, lessonData }) => ({
        url: `/${courseSlug}/lessons/${lessonId}`,
        method: "PUT",
        body: lessonData,
      }),
      invalidatesTags: (result, error, { courseSlug }) => [
        { type: "Courses", id: courseSlug },
      ],
    }),

    deleteLesson: builder.mutation({
      query: ({ courseSlug, lessonId }) => ({
        url: `/${courseSlug}/lessons/${lessonId}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, { courseSlug }) => [
        { type: "Courses", id: courseSlug },
      ],
    }),

    /* ================= ATTEMPT SYSTEM (Used in CourseLearningPage) ================= */
    startLessonExercise: builder.mutation({
      query: ({ lessonId }) => ({
        url: `/student/lessons/${lessonId}/start`,
        method: "POST",
      }),
      invalidatesTags: ["Attempts"],
    }),

    saveExerciseAnswer: builder.mutation({
      query: ({ attemptId, exerciseId, answer }) => ({
        url: `/student/attempts/${attemptId}/answer`,
        method: "POST",
        body: { exerciseId, answer },
      }),
      invalidatesTags: (result, error, { attemptId }) => [
        { type: "Attempts", id: attemptId },
      ],
    }),

    submitLessonExercise: builder.mutation({
      query: ({ attemptId, answers, timeSpent }) => ({
        url: `/student/attempts/${attemptId}/submit`,
        method: "POST",
        body: { answers, timeSpent },
      }),
      invalidatesTags: ["Results", "Progress", "Attempts"],
    }),

    getAttemptById: builder.query({
      query: (attemptId) => `/student/attempts/${attemptId}`,
      providesTags: (result, error, attemptId) => [
        { type: "Attempts", id: attemptId },
      ],
      keepUnusedDataFor: 0,
    }),

    /* ================= FILE UPLOADS ================= */
    uploadCourseFile: builder.mutation({
      query: (formData) => ({
        url: "/upload/file",
        method: "POST",
        body: formData,
      }),
    }),

    uploadCourseImage: builder.mutation({
      query: (formData) => ({
        url: "/upload/image",
        method: "POST",
        body: formData,
      }),
    }),

    uploadCourseAudio: builder.mutation({
      query: (formData) => ({
        url: "/upload/audio",
        method: "POST",
        body: formData,
      }),
    }),

    uploadCourseVideo: builder.mutation({
      query: (formData) => ({
        url: "/upload/video",
        method: "POST",
        body: formData,
      }),
    }),
  }),
});

/* =========================================
   EXPORT HOOKS
========================================= */
export const {
  useGetCoursesQuery,
  useGetPublishedCoursesQuery,
  useGetCreatorCoursesQuery,
  useGetCourseBySlugQuery,
  useGetCourseByIdQuery,
  useCreateCourseMutation,
  useEditCourseMutation,
  useDeleteCourseMutation,
  useGetCourseProgressQuery,
  useGetCourseResultQuery,
  useGetStudentCourseResultQuery,
  useAddLessonMutation,
  useEditLessonMutation,
  useDeleteLessonMutation,
  useStartLessonExerciseMutation,
  useSaveExerciseAnswerMutation,
  useSubmitLessonExerciseMutation,
  useGetAttemptByIdQuery,
  useUploadCourseFileMutation,
  useUploadCourseImageMutation,
  useUploadCourseAudioMutation,
  useUploadCourseVideoMutation,
} = courseApi;